import { Component, OnInit, EventEmitter, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { DCInput } from "../dynamic.service";

@Component({
    selector: 'confirm-dialog',
    template: `<dialog-window [title]="title" (close)="onCancel()" modal="true" >
                <span [innerText]="message"></span>
                <div dialog-footer class="handler-buttons">
                    <button tabindex="3" #buttonOk (click)="onOk()" class="blue-button">OK</button>&nbsp;
                    <button tabindex="2" (click)="onCancel()" class="blue-button" autofocus>Отмена</button>
                </div>
              </dialog-window>`
})

export class ConfirmDialogComponent implements OnInit, OnDestroy, DCInput, AfterViewInit {
    /**
     * Заголовок
     */
    title = "Внимание!";
    /**
     * Текст выводимого сообщения
     */
    message = "Важное сообщение.";
    /**
     * Подписчик обработчик кнопок OK или Отмена
     */
    onOkEmitter:EventEmitter<boolean> = new EventEmitter();
    /**
     * Подписчик для удаления компоненты
     */
    destroyEmitter:EventEmitter<null> = new EventEmitter();
    @ViewChild("buttonOk", {static: true}) buttonOk:ElementRef;
    constructor() { }

    ngOnInit() { }
    ngOnDestroy(){
        this.destroyEmitter.complete();
        this.onOkEmitter.complete();
    }    
    ngAfterViewInit(){
        // Фокусируем кнопку, чтобы по enter нажималось ок.
        (<HTMLButtonElement>this.buttonOk.nativeElement).focus();
    }
    /**
     * Закрытие окна
     */
    close(){
        this.destroyEmitter.emit(null);
    }
    /**
     * Нажатие на кнопку ОК
     */
    onOk(){
        this.onOkEmitter.emit(true);
        this.close();
    }
    /**
     * Нажатие на кнопку Отмена
     */
    onCancel(){
        this.onOkEmitter.emit(false);
        this.close()
    }
}